module.exports = __webpack_public_path__ + "static/hero-landing-improve-40339a7cd1767a834c3ffdf7cfb05881.png";